{
  "name": "phoenix-event-display",
  "version": "4.2.3",
  "description": "API for web-based experiment independent event display.",
  "main": "dist/index",
  "types": "dist/index",
  "author": "Phoenix contributors (https://github.com/HSF/phoenix/graphs/contributors)",
  "license": "Apache-2.0",
  "homepage": "http://github.com/HSF/phoenix/tree/main/packages/phoenix-event-display#readme",
  "repository": {
    "type": "git",
    "url": "git://github.com/HSF/phoenix.git"
  },
  "files": [
    "dist"
  ],
  "scripts": {
    "tsc": "tsc",
    "tsc:build": "tsc -p tsconfig.build.json",
    "start": "yarn tsc:build --watch",
    "build": "rimraf ./dist && yarn tsc:build",
    "build:esm": "yarn tsc:build --module es2018 --target es5 --outDir dist/esm",
    "build:cjs": "yarn tsc:build --module commonjs --target es5 --outDir dist/cjs",
    "build:bundle": "webpack -c configs/webpack.conf.js",
    "tsc-d": "yarn tsc:build --declaration --emitDeclarationOnly --esModuleInterop --outFile dist/index.d.ts",
    "prepublishOnly": "yarn build:bundle",
    "docs": "node scripts/gen-api-docs.js",
    "docs:coverage": "yarn compodoc -p configs/compodoc.conf.json --coverageTest 100",
    "test": "jest --config configs/jest.conf.js",
    "test:coverage": "yarn test --coverage",
    "test:ci": "yarn test:coverage --maxWorkers=2 --silent",
    "test:debug": "yarn test --runInBand",
    "prepare": "yarn build",
    "prettier": "prettier --config ../../.prettierrc --ignore-path ../../.prettierignore",
    "prettier:check": "yarn prettier --check .",
    "prettier:write": "yarn prettier --write .",
    "eslint": "eslint src/**/*.ts ",
    "eslint:fix": "yarn eslint --fix"
  },
  "dependencies": {
    "@tweenjs/tween.js": "^25.0.0",
    "dat.gui": "^0.7.9",
    "html2canvas": "^1.4.1",
    "jsroot": "^7.11.0",
    "jszip": "^3.10.1",
    "three": "~0.184.0"
  },
  "devDependencies": {
    "@babel/helper-string-parser": "^7.27.1",
    "@compodoc/compodoc": "^1.2.1",
    "@types/dat.gui": "^0.7.13",
    "@types/three": "~0.184.1",
    "esbuild-loader": "^4.4.0",
    "jest": "^29.7.0",
    "ts-jest": "^29.3.4",
    "typescript": "~5.8.2",
    "webpack": "^5.103.0",
    "webpack-cli": "^6.0.1"
  },
  "peerDependencies": {
    "jspdf": "*"
  },
  "browser": {
    "@resvg/resvg-js": false
  }
}
